import { render, staticRenderFns } from "./HubSummaryPendingCases.vue?vue&type=template&id=66b10dfe"
import script from "./HubSummaryPendingCases.vue?vue&type=script&lang=js"
export * from "./HubSummaryPendingCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports